<script setup>
import {computed, onMounted, ref, watch} from 'vue';
import axios from '@/plugins/axios.js';

const props = defineProps({
  trendId: {
    type: [String, Number],
    required: true
  }
});
const emits = defineEmits(['change', 'update:trendId']);
const trend = ref({});
const isLoaded = ref(false);
const _trendId = ref(props.trendId);
const getTrendId = computed(() => _trendId.value || props.trendId);

const compiledComponent = computed(() => {
  if (!trend.value?.template) {
    return {
      template: '<div>Loading...</div>',
      data() {
        return {
          trend: {},
        };
      },
    };
  }
  // 역슬래시 제거 및 \n을 공백으로 변경
  const cleanedTemplate = trend.value.template.replace(/\\/g, '').replace(/\n/g, ' ');
  // 필요한 컴포넌트 등록 (예시: ProductListItem 등)
  // import ProductListItem from '@/components/ui/ProductListItem.vue';
  return {
    template: cleanedTemplate,
    data() {
      const trendData = {...trend.value};
      delete trendData.template;
      return {
        trend: trendData,
      };
    },
    methods:{
      change(value) {
        console.log('Change event triggered with value:', value);
        this.$emit('change', value);
        this.$emit('update:trendId', value);
      }
    }
  };
});

const getData = async () => {
  const response = await axios.get(`/api/v1/trends/${getTrendId.value}`);
  trend.value = response.data;
  isLoaded.value = true;
};

onMounted(getData);

watch(() => props.trendId, async () => {
  _trendId.value = props.trendId;
  await getData();
});

const changeEmit = (value) => {
  emits('change', value);
  emits('update:trendId', value);
  _trendId.value = value;
  getData();
};

</script>

<template>
  <component
    :is="compiledComponent"
    v-if="isLoaded"
    @change="changeEmit"
  />
</template>

<style scoped>

</style>
